import CourseDetailPage from './CourseDetailPage';
export default CourseDetailPage; 